<template>
  <div>
    <!-- <Sticky>
      <NavBar />
    </Sticky>
    <div class="home">
      <Row>
        <Swipe class="banner_ws_w" :autoplay="3000">
          <SwipeItem v-for="(image, index) in BannerImgIinst" :key="index">
            <VanImage class="banner_ws_w" fit="cover" :src="image.layoutImg" />
          </SwipeItem>
        </Swipe>
      </Row>
      <div class="icon_img_box">
        <Row type="flex" justify="space-between">
          <Col v-for="(item, index) in IconList" :key="index" span="4">
            <div class="icon_item" @click="changeNav(item, index)">
              <div class="icon center">
                <i class="iconfont" :class="[`${item.icon}`]" />
              </div>
              <span class="text">{{ item.text }}</span>
            </div>
          </Col>
        </Row>
      </div>
      <Row type="flex" justify="center">
        <VanImage
          class="nwe_top"
          fit="contain"
          :src="require('@/assets/image/news.png')"
        />
      </Row>
      <Row class="nr_body">
        <div class="new_box">
          <div
            v-for="(nwe_value, new_index) in new_list.slice(0, 3)"
            :key="new_index"
            class="nwe_list"
            @click="Setrouterlist('newsbody', nwe_value)"
          >
            <div class="left-info">
              <h1>
                {{ nwe_value.day }}
              </h1>
              <p>{{ nwe_value.year }}/{{ nwe_value.month }}</p>
            </div>
            <div class="info-right">
              <p class="bt_text">
                {{ nwe_value.noticeName }}
              </p>
              <p class="text_nr">
                {{ nwe_value.noticeIntro }}
              </p>
            </div>
          </div>
          <span class="new_btn" @click="Setrouter('news')"> 查看更多 </span>
        </div>
      </Row>
      <Row type="flex" justify="center">
        <VanImage
          class="nwe_top"
          fit="contain"
          :src="require('@/assets/image/anjian.png')"
        />
      </Row>
      <Row class="nr_body list_body">
        <div class="list_tilet_box">
          <p class="f_l list_t_l">案号</p>
          <p class="f_r list_t_r">立案日期</p>
        </div>
        <Cell
          v-for="item in list"
          :key="item.caseCode"
          :title-class="['vellsasdsa']"
          :title="item.caseCode"
          :value="item.buildTime.substring(0, 10)"
        />
      </Row>
    </div>

    <footers /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import {
  Lazyload,
  Swipe,
  SwipeItem,
  Empty,
  Image as VanImage,
  Search,
  Tab,
  Tabs,
  List,
  Cell,
  CellGroup,
  Divider,
  Tabbar,
  TabbarItem,
  Toast,
  Dialog,
  Tag,
  Col,
  Row
} from 'vant'
import NavBar from '@/components/NavBar'
import footers from '@/components/footer'

import {
  getaxios,
  createArticle,
  fetchList,
  PostData,
  fetchPv,
  getaxiosdata,
  updateArticle
} from '@/api/official-article'

export default {
  name: 'Home',
  components: {
    Lazyload,
    footers,
    Swipe,
    SwipeItem,
    NavBar,
    VanImage,
    Search,
    Tab,
    Tabs,
    List,
    Cell,
    CellGroup,
    Divider,
    Tabbar,
    TabbarItem,
    Toast,
    Dialog,
    Tag,
    Col,
    Row,
    Empty
  },
  data() {
    return {
      new_list: '',
      images: [
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg'
      ],
      active: 2,
      search_value: '',
      city_name: '定位中', // 城市名称
      list: [],
      loading: false,
      isDialog: true,
      finished: false,
      gps: {
        page: this.page
      }, // 定位信息
      page: 1, // 当前分页
      islist: false,
      total: '', // 总数量
      last_page: '', // 总页数
      isgps: true,
      banner_img_list: '',
      IconList: [
        {
          text: '裁判文书公开',
          icon: 'iconwenshu-xuanfu',
          url: 'https://wenshu.court.gov.cn',
          urltype: true // true代表是外部链接 felse：路由跳转
        },
        {
          text: '开庭公告',
          icon: 'iconkaitinggonggao',
          url: 'courtnotice'
        },
        {
          text: '公告送达',
          icon: 'icongongkai',
          url: 'notice'
        },
        {
          text: '诉讼规程',
          icon: 'iconhands',
          url: 'rules'
        }
        // {
        //   text: '特约调解',
        //   icon: 'iconhetongguanli-',
        //   url: 'mediate'
        // }
      ],
      img_url:
        'data:image/png;base64,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'
    }
  },
  computed: {
    BannerImgIinst() {
      const data = this.$store.state.user.web_means
      for (const i of data) {
        if (i.layoutId == 'BANNER') {
          return i.imgs
        }
      }
    }
  },
  created() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#F7F7F7')
    this.GetNewList()
    this.onLoad()
  },
  methods: {
    Setrouterlist(url, data) {
      this.$router.push({
        path: `/${url}`,
        query: { noticeId: data.noticeId }
      })
    },
    Setrouter(url, data) {
      this.$router.push({ path: `/${url}` })
    },
    onLoad() {
      PostData('api/home/caseLatest', {
        limit: 10,
        page: 1,
        orgCode: 'G001'
      }).then((response) => {
        this.list = response.data
      })
    },
    // 获取新闻
    GetNewList() {
      PostData('api/home/getNews', {
        limit: 10,
        page: 1,
        orgCode: 'G001'
      }).then((response) => {
        for (const v of response.data) {
          v.year = v.creatorTime.slice(0, 4)
          v.month = v.creatorTime.slice(5, 7)
          v.day = v.creatorTime.slice(8, 10)
        }
        this.new_list = response.data
      })
    },

    //   查看更多
    lookMore(row) {
      if (row) {
        // 查看详情
        this.$router.push({
          path: 'newsbody',
          query: {
            noticeId: row.noticeId
          }
        })
      } else {
        // 跳转新闻中心
        this.$router.push({ path: 'news' })
      }
    },
    changeNav(item, index) {
      if (item.urltype) {
        window.open(item.url, '_blank') // 新窗口打开外链接
      } else if (item.newurltype) {
        const url = window.location.href
        const dz_url = url.split('#')[0]
        window.open(`${dz_url}#/login`, '_blank') // 新窗口打开外链接
      } else {
        this.$router.push({ path: item.url })
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.list_body {
  margin-bottom: 15px;
}

.list_tilet_box {
  height: 50px;
  background: #E34644;
  line-height: 50px;
  font-size: 13px;
  color: #fff;

  .list_t_l {
    padding-left: 20px;
  }

  .list_t_r {
    padding-right: 38px;
  }
}

.new_btn {
  font-size: 12px;
  color: #E34644;
  float: right;
  margin-top: 15px;
  margin-bottom: 30px;
}

.nwe_list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.info-right {
  background-color: #fff;
  width: 290px;
  position: absolute;
  left: 54px;
  height: 68px;
  top: 0px;

  .text_nr {
    padding: 0 12px;
    margin-top: 8px;
    font-size: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 15px;
    color: #787878;
  }

  .bt_text {
    color: #000;
    padding: 0 12px;
    margin-top: 10px;
    font-size: 15px;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.nr_body {
  padding: 0 15px;
  margin-top: 15px;
}

.left-info {
  float: left;
  width: 54px;
  height: 68px;
  margin-bottom: 10px;
  background: #E34644;
  text-align: center;
  color: #fff;

  h1 {
    padding-top: 16px;
    padding-bottom: 10px;
    font-size: 18px;
  }

  p {
    font-size: 10px;
  }
}

.nwe_top {
  height: 60px;
}

.icon_item {
  align-items: center;
  cursor: pointer;
  flex-direction: column;
  display: flex;
  text-align: center;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: 42px;
    border-radius: 50%;
    border: 1px dashed #f11f1f;
    color: #e40000;

    i {
      font-size: 20px;
    }
  }

  span {
    margin-top: 13px;
    font-size: 10px;
    color: black;
  }
}

.van-col:nth-child(2) .icon_item .icon .iconfont {
  margin-left: 16px;
  margin-top: 8px;
  font-size: 26px;
}

.icon_img_box {
  background-color: #fff;
  padding-top: 15px;
  padding-bottom: 13px;
  margin: 13px 15px 25px;
}

.banner_ws_w {
  height: 150px;
}

.custom-image {
}

.title-bod {
  text-align: center;
}

.search-box {
}

.search_label {
  float: left;

  p {
    font-size: 10px;
    padding: 8px 8px;
    margin-left: 20px;
    background-color: rgb(247, 248, 250);
  }
}

.search-body {
  margin-right: 20px;

  .van-search {
    padding-left: 0;
  }
}

.cous-box {
  margin: 0 -6px;

  .cous-text {
    margin: 0 6px;
    padding: 1px 3px;
  }
}

.title-text {
  font-size: 20px;
}

.horizontal {
  width: 100%;
  height: 10px;
  background-color: #f5f5f5;
}
</style>
